<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div style="display: flex; padding-top: 10px;">
			<div>打卡时间设置：</div>
		</div>
		<div style="display: flex; padding-top: 10px;">
			<div style="width: 250px;" class="d-flex">
				<div style="margin-right: 10px;">打卡开始</div>
				<el-time-select v-model="list.sbsj_a" :picker-options="{ start: '07:00', step: '00:15', end: '12:00' }" placeholder="选择时间" size="mini" style="width: 120px;"></el-time-select>
			</div>
			<div style="width: 250px;" class="d-flex">
				<div style="margin-right: 10px;">打卡结束</div>
				<el-time-select v-model="list.sbsj_b" :picker-options="{ start: '07:00', step: '00:15', end: '12:00' }" placeholder="选择时间" size="mini" style="width: 120px;"></el-time-select>
			</div>
		</div>
		<div style="display: flex; padding-top: 10px;padding-bottom: 20px;">
			<el-button type="primary" @click="onSubmit" size="mini">保存打卡时间设置</el-button>
		</div>
		
		
		<div>
			<div>打卡坐标设置：</div>
		</div>
		<div>
			<div style="margin-top: 10px;border: 1px solid rgb(0,0,0,0.1);padding: 10px;" v-for="(item,index) in ckzb">
				<div class="d-flex" style="align-items: center;">
					<div>{{item.name}}</div>
					<el-button style="margin-left: 20px;" type="success" @click="cancelMap(item,index)" size="mini">坐标</el-button>
				</div>
				<div class="d-flex" style="align-items: center;margin-top: 6px;margin-bottom: 6px;">
					<div>维度：{{item.zb_x}}</div>
					<div style="margin-left: 20px;">经度：{{item.zb_y}}</div>
				</div>
				<div class="d-flex" style="align-items: center;">
					<div>打卡范围</div>
					<el-input-number style="margin-left: 20px;" v-model="item.dkfw" :min="1" :max="10" size="mini"></el-input-number>
					<div style="margin-left: 4px;color: #0066ff;">km</div>
				</div>
				
			</div>
			<baiduMap @cancel="cancelMapgb" @map-confirm="confirmMap" :visible="showMapComponent"
				:centers='{lng:parseFloat(form.zb_y),lat:parseFloat(form.zb_x)}' :key="keyInfo"></baiduMap>
		</div>
		<div style="display: flex; padding-top: 10px;padding-bottom: 50px;">
			<el-button type="primary" @click="onSubmit_ck" size="mini">保存打卡坐标设置</el-button>
		</div>
		
		
	</div>
</template>

<script>
	import common from '@/common/mixins/common.js'; // 引入 全局共公样式
	import buttonSearch from '@/components/common/button-search.vue';
	import baiduMap from '@/components/baiduMap.vue';
	import {
		mapState
	} from 'vuex'; // 引入 全局 公共数据
	export default {
		mixins: [common], // 引入mixins里的common.js
		inject: ['layout'], // 依赖注入
		data() {
			return {
				list:{
					sbsj_a:'',
					sbsj_b:''
				},
				ckzb:[],
				form:{
					zb_x:'',
					zb_y:''
				},
				showMapComponent: false,
				xzck:0,
				keyInfo:0
			};
		},
		components: {
			buttonSearch,
			baiduMap
		},
		computed: {
			...mapState({
				user: state => state.user.user
			})
		},
		mounted() {
			this.getlists()
		},
		methods: {
			getlists(){
				this.axios.get('/admin/sbsz', {
						token: true
					}).then(res => {
						this.list = res.data.data
					});
				this.axios.get('/admin/sbzb', {
						token: true
					}).then(res => {
						this.ckzb = res.data.data
					});
			},
			onSubmit(){
				let data = this.list
				this.axios.post('/admin/sbsz',{data}, {
						token: true
					}).then(res => {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.getlists()
					});
			},
			onSubmit_ck(){
				let data = this.ckzb
				this.axios.post('/admin/sbzb',{data}, {
						token: true
					}).then(res => {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.getlists()
					});
			},
			confirmMap(e) {
				this.ckzb[this.xzck].zb_y = parseFloat(e.lng)
				this.ckzb[this.xzck].zb_x = parseFloat(e.lat)
				this.showMapComponent = !this.showMapComponent
			},
			// 定位
			cancelMap(e,index) {
				this.keyInfo += 1
				this.form.zb_x = e.zb_x
				this.form.zb_y = e.zb_y
				this.xzck = index
				this.showMapComponent = !this.showMapComponent
			},
			cancelMapgb(){
				this.showMapComponent = !this.showMapComponent
			}
		}
	};
</script>

<style></style>